import { IconWrapper } from '../runtime';
export default IconWrapper('folder-recycle-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 20.25C1.00736 20.25 0 19.2426 0 18L0 3C0 1.75736 1.00736 0.75 2.25 0.75L6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3L21.75 3C22.9926 3 24 4.00736 24 5.25L24 18C24 19.2426 22.9926 20.25 21.75 20.25L2.25 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 22.5C1.00736 22.5 0 21.4926 0 20.25L0 7.5C0 6.25736 1.00736 5.25 2.25 5.25L21.75 5.25C22.9926 5.25 24 6.25736 24 7.5L24 20.25C24 21.4926 22.9926 22.5 21.75 22.5L2.25 22.5Z",
      "fill": 'url(#' + props.id + 'c98a2b23' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.25 8.8125C10.8358 8.8125 10.5 9.14829 10.5 9.5625V10.3125H7.875C7.66789 10.3125 7.5 10.4804 7.5 10.6875V11.4375C7.5 11.6446 7.66789 11.8125 7.875 11.8125H8.53125L9.20332 17.5251C9.24776 17.9028 9.56787 18.1875 9.94819 18.1875H14.0518C14.4321 18.1875 14.7522 17.9028 14.7967 17.5251L15.4688 11.8125H16.125C16.3321 11.8125 16.5 11.6446 16.5 11.4375V10.6875C16.5 10.4804 16.3321 10.3125 16.125 10.3125H13.5V9.5625C13.5 9.14829 13.1642 8.8125 12.75 8.8125H11.25ZM12 13.3125C11.6893 13.3125 11.4375 13.5643 11.4375 13.875V15.75C11.4375 16.0607 11.6893 16.3125 12 16.3125C12.3107 16.3125 12.5625 16.0607 12.5625 15.75V13.875C12.5625 13.5643 12.3107 13.3125 12 13.3125Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'c98a2b23',
      "x1": "2.25",
      "y1": "6.43828",
      "x2": "19.1823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});